import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import React, { useState } from "react";
import { twJoin } from "tailwind-merge";

import { AgentVersionStatus } from "src/agents/types";
import { Icon } from "src/base-components/Icon";

export const AgentVersionName: React.FC<{
  name: string;
  status: AgentVersionStatus;
}> = ({ name, status }) => {
  return (
    <div className="flex items-center gap-1">
      <AgentVersionStatusIndicator status={status} />
      {name}
    </div>
  );
};

type AgentVersionNameExpandableProps = {
  name: string;
  description: string;
  status: AgentVersionStatus;
};

export const AgentVersionNameExpandable: React.FC<
  AgentVersionNameExpandableProps
> = ({ name, description, status }) => {
  const [expanded, setExpanded] = useState(false);

  const onClickExpand = () => setExpanded(!expanded);

  return (
    <div
      className={twJoin(
        "flex flex-col transition-[height]",
        expanded ? "h-auto" : "h-6",
      )}
    >
      <div className="flex items-center gap-1.5">
        <button
          className="p-1 transition-[transform]"
          data-loc="agent-version-expand"
          style={{ transform: expanded ? "rotate(90deg)" : "rotate(0deg)" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClickExpand();
          }}
        >
          <Icon
            color="text-gray-500 hover:text-gray-700"
            icon={faChevronRight}
            size="2xs"
          />
        </button>
        <AgentVersionStatusIndicator status={status} />
        <div className="truncate">{name}</div>
      </div>
      <div
        key="description"
        className={twJoin(
          "ml-3 mt-3 translate-x-px overflow-hidden whitespace-pre-line border-l border-gray-200 pl-5 font-inter-normal-12px",
          !description && "text-gray-400",
        )}
      >
        {description || "No description"}
      </div>
    </div>
  );
};

export const AgentVersionStatusIndicator: React.FC<{
  status: AgentVersionStatus;
}> = ({ status }) => {
  return (
    <Icon
      color={status === "published" ? "text-green-400" : "text-yellow-400"}
      icon={faCircle}
      size="3xs"
    />
  );
};
